import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vue-awesome/icons';
import './../node_modules/bulma/css/bulma.css';
import Notifications from 'vue-notification';

Vue.config.productionTip = false;
Vue.use(Notifications);

Vue.directive('ally-scroll', {
  inserted(el) {
	el.scrollIntoView();
  },
});

Vue.directive('ally-action-focus', {
  inserted(el) {
  	const elements = el.getElementsByClassName('ally-option-button');
  	// @ts-ignore
  	elements[0].focus();
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
